import * as $ from 'jquery';

export default (
    function() {
        var changeTrainingPrice = function (e) {
            var $selected = $(this).find('option:selected');
            var $priceField = $('input[name="price"]');

            if ($selected.length > 0) {
                if ($priceField.length > 0) {
                    var $trainingPrice = $selected.data('price');
                    $priceField.val($trainingPrice);
                } else {
                    console.log('No price found');
                }
            } else {
                console.log('No selected option found');
            }
        };

        $('#edition_training_id').on('change', changeTrainingPrice);
        if ($(".invalid-feedback")[0]){
            console.log('Form invalid');
        } else {
            if(!$('input[name="price"]').val() > 0){
                changeTrainingPrice.call($('#edition_training_id'));
                console.log('Fresh page');
            }
        }
    }()
);
